import { ContentUsedProductCertificate } from "@/@types/index"
import { ContentUsedProducCertificateResponse } from "../usedProductCertificate/models/ContentUsedProducCertificateResponse";

export function mapUsedProductCertificate(slide: ContentUsedProducCertificateResponse): ContentUsedProductCertificate {
  return {
        id: slide.id,
        section_type: slide.section_type,
        section_one: slide.section_one,
        image_one: slide.image_one,
        full_image_one: slide.full_image_one || "",
        section_two: slide.section_two,
        image_two: slide.image_two,
        full_image_two: slide.full_image_two,
        section_four: slide.section_four,
        image_four: slide.image_four,
        full_image_four: slide.full_image_four,
  }
} 